
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hsn-code/search/[searcKeyword]",
      function () {
        return require("private-next-pages/hsn-code/search/[searcKeyword].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hsn-code/search/[searcKeyword]"])
      });
    }
  